module.exports = __webpack_public_path__ + "img/icon-options-2.0eb478c1.svg";